<template>
	<div class="meeting-header">
		<a href="#/vipmeeting/start" class="logo">
			<img class="logo-img" src="@/assets/shmeeting/logo.jpg">
		</a>
		<div class="link-items">
			<a href="#/vipmeeting/start" class="item">首页</a>
			<a href="#/vipmeeting/orders" class="item">我的预约</a>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.meeting-header {
		box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
		z-index: 9999;
		display:flex;
		flex-direction: row;
		background-color:white;
		padding:0 40px;
		width:100vw;
		height:0.8rem;
		position:fixed;
		align-items: center;
		.logo {
			flex:1;
			.logo-img {
				cursor: pointer;
				height:50px;
				display:block;
			}
		}
		.link-items {
			flex:1;
			display:flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
			.item {
				color: $theme-color;
				cursor: pointer;
				padding:0 20px;
				@include fontSize($font-size-18)
			}
		}
	}
	@media (max-width: 768px){
		.meeting-header {
			padding:0 10px;
			height:2rem;
			.logo {
				.logo-img {
					height:30px;
				}
			}
		}
	}
</style>